import ChairHeart from '../src/ChairHeart';
export default ChairHeart;
